/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Billing_Bills_List_Col_StatusInputs */

const es_admin_billing_bills_list_col_status = /** @type {(inputs: Admin_Billing_Bills_List_Col_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estado`)
};

const en_admin_billing_bills_list_col_status = /** @type {(inputs: Admin_Billing_Bills_List_Col_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Status`)
};

/**
* | output |
* | --- |
* | "Status" |
*
* @param {Admin_Billing_Bills_List_Col_StatusInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const admin_billing_bills_list_col_status = /** @type {((inputs?: Admin_Billing_Bills_List_Col_StatusInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Billing_Bills_List_Col_StatusInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_admin_billing_bills_list_col_status(inputs)
	return en_admin_billing_bills_list_col_status(inputs)
});
export { admin_billing_bills_list_col_status as "admin.billing.bills_list.col_status" }